// 核心逻辑来源 clipboard
// createed by jiabo.zhang
import i18nInstance from "@root/i18n";
import Clipboard from "clipboard";
import { Message } from "element-ui";

const MAX_CONTENT_LENGTH = 40;
const MESSAGE_DURATION = 800;

export default {
  install: Vue => {
    Vue.directive("clipboard-easy", {
      bind(el, binding) {
        // save state
        el._COPIED_TEXT_ = binding.value || getInnerText(el);

        const icon = new Vue({
          render(h) {
            return h(
              "el-tooltip",
              {
                props: {
                  effect: "dark",
                  content: i18nInstance.t("Root.Clipboard.ToCopy"),
                  placement: "bottom"
                }
              },
              [
                h("i", {
                  class: ["el-icon-copy-document", "gt-clip__icon"],
                  style: {
                    "margin-left": "4px",
                    cursor: "pointer"
                  },
                  on: {
                    click() {
                      easyClipboard(el._COPIED_TEXT_);
                    }
                  }
                })
              ]
            );
          }
        });

        icon.$mount();

        el.appendChild(icon.$el);
      },

      componentUpdated(el, binding) {
        // save state
        el._COPIED_TEXT_ = binding.value || getInnerText(el);
      }
    });
  }
};

function getInnerText(el) {
  return el.innerText;
}

function easyClipboard(text) {
  var btn = document.createElement("button");
  var clipboard = new Clipboard(btn, {
    text: function () {
      return text;
    },
    action: function () {
      return "copy";
    },
    container: document.body
  });

  clipboard.on("success", function () {
    if (text) {
      Message({
        type: "success",
        message: i18nInstance.t("Root.Clipboard.Success", {
          content:
            text.length > MAX_CONTENT_LENGTH
              ? `${text.slice(0, MAX_CONTENT_LENGTH)} ...`
              : text
        }),
        duration: MESSAGE_DURATION
      } as any);
    }

    clipboard.destroy();
  });

  clipboard.on("error", function () {
    clipboard.destroy();
    throw new Error("V-Clipboard-Easy: Copied failed");
  });

  document.body.appendChild(btn);

  btn.click();

  document.body.removeChild(btn);
}
